import React from "react";
import TrayMeter from "@/components/TrayMeter";
import BatchStockBadge from "@/components/BatchStockBadge";
import { useBatch, pizzaCount, pizzasLeft } from "@/context/BatchContext";

export default function CartTrayNudge({ items }) {
  const { batch } = useBatch();
  const n = pizzaCount(items, batch);
  const left = pizzasLeft(batch);
  if (!batch || left === null) return null;
  const rem = n % 4;
  const need = rem ? 4 - rem : 0;
  const stockLeft = left - n;
  let msg;
  if (n === 0) msg = left === 0 ? "Pizzas are sold out for now." : "Pizzas come 4 to a tray — start filling yours.";
  else if (!need) msg = `Full tray${n > 4 ? "s" : ""}! ${n / 4} tray${n > 4 ? "s" : ""} of fresh BIGA pizza.`;
  else if (stockLeft <= 0) msg = `${rem} of 4 – that's the last of them.`;
  else msg = `${rem} of 4 – add ${Math.min(need, stockLeft)} more to ${stockLeft >= need ? "fill a tray" : "grab the last pizzas"}`;
  return (
    <div className="bg-white border-2 border-biga-ink/10 rounded-2xl p-3 space-y-2" data-testid="cart-tray-nudge">
      <BatchStockBadge testid="cart-batch-badge" />
      <div className="flex items-center gap-3">
        <div className="w-28 shrink-0"><TrayMeter filled={n === 0 ? 0 : rem || 4} size="sm" testid="cart-tray-meter" /></div>
        <p className="text-xs font-bold text-biga-ink/70" data-testid="cart-tray-message">{msg}</p>
      </div>
    </div>
  );
}
